export const brandIdMap = {
  EM: {
    id: "EM",
    cd: "1100",
    type: "이마트",
  },
  TR: {
    id: "TR",
    cd: "1200",
    type: "트레이더스 홀세일 클럽",
  },
  NB: {
    id: "NB",
    cd: "1300",
    type: "노브랜드",
  },
  ED: {
    id: "ED",
    cd: "1400",
    type: "에브리데이",
  },
  LD: {
    id: "LD",
    cd: "1500",
    type: "SSG 랜더스",
  },
};
